import styles from "./PassportPartPhoto_Reusable.module.css";

import sample_1 from "../../../assets/images/edit_screen/PassportPartPhoto/sample_1.png";
import EditScreenSelector from "../../Reusables/EditScreenSelector";
import { Link, scroller } from "react-scroll";
const PassportPartPhotoReusable = ({
  key,
  index,
  callback,
  state,
  //new stuff
  saveThisProduct,
  changeCopyDetails,
  selectedCopyDetails,
  currentPageNumber,
  totalPageNumber,
  confirmEdits,
}) => {
  let { name, date, time, weight, height } = state;
  const changeState = (key, value) => {
    state[key] = value;
    callback(state);
  };
  const copyOptions = [];
  for (let i = 1; i < currentPageNumber; i++) {
    copyOptions.push(i + "個目と同じ");
  }
  copyOptions.push("別のデザインで作る");
  // let copySelected =
  //   selectedCopyDetails === currentPageNumber
  //     ? currentPageNumber + "個目の写真"
  //     : selectedCopyDetails+"個目の写真";
  let copySelected = selectedCopyDetails + "個目の写真";
  const extractNumber = (s, currentPageNumber, totalPageNumber) => {
    for (let i = totalPageNumber; i > 0; i--) {
      if (s.includes(i)) {
        return i;
      }
    }
    return currentPageNumber;
  };
  return (
    <div className={styles.main_div}>
      <div className={styles.top_hr}></div>
      <div className={styles.spacing01}></div>
      <div className={styles.header_section_main}>
        {currentPageNumber === 1 && (
          <div name="情報入力" className={styles.header_section}>
            情報入力
          </div>
        )}

        {totalPageNumber > 1 && (
          <div
            className={styles.header_number}
            name={"editsection" + currentPageNumber}
          >
            {currentPageNumber + "個目"}
          </div>
        )}
      </div>
      {currentPageNumber > 1 && (
        <div className={styles.multi_page_selector_wrapper}>
          <div className={styles.multi_page_selector}>
            <EditScreenSelector
              takeupspace={true}
              options={copyOptions}
              callback={(value) => {
                console.log(value);
                changeCopyDetails(
                  extractNumber(value, currentPageNumber, totalPageNumber),
                  index,
                );
                // changeState("sec03textbox", value);
                // setSec03textbox(value);
              }}
              selected={copySelected}
            />
          </div>
        </div>
      )}
      <div className={styles.spacing02}></div>
      {selectedCopyDetails === currentPageNumber && (
        <div className={styles.main_form_div}>
          <img src={sample_1} height={397} width={281} alt="sample" />
          <div className={styles.form_section}>
            <div className={styles.single_row}>
              <div className={styles.col_1}>
                <div>名前（アルファベット）</div>
                <div>フルネームor下のお名前</div>
              </div>
              <div className={styles.col_2}>
                <input
                  className={styles.input_box}
                  value={name}
                  onChange={(e) => {
                    changeState("name", e.target.value);
                  }}
                />
              </div>
            </div>
            <div className={styles.single_row}>
              <div className={styles.col_1}>
                <div>名前（アルファベット）</div>
              </div>
              <div className={styles.col_2}>
                <input
                  className={styles.input_box}
                  value={date}
                  onChange={(e) => {
                    changeState("date", e.target.value);
                  }}
                />
              </div>
            </div>
            <div className={styles.single_row}>
              <div className={styles.col_1}>
                <div>出生時間</div>
              </div>
              <div className={styles.col_2}>
                <input
                  className={styles.input_box}
                  value={time}
                  onChange={(e) => {
                    changeState("time", e.target.value);
                  }}
                />
              </div>
            </div>
            <div className={styles.single_row}>
              <div className={styles.col_1}>
                <div>出生時の身長</div>
              </div>
              <div className={styles.col_2}>
                <input
                  className={styles.input_box}
                  value={height}
                  onChange={(e) => {
                    changeState("height", e.target.value);
                  }}
                />
              </div>
            </div>
            <div className={styles.single_row}>
              <div className={styles.col_1}>
                <div>出生時の体重</div>
              </div>
              <div className={styles.col_2}>
                <input
                  className={styles.input_box}
                  value={weight}
                  onChange={(e) => {
                    changeState("weight", e.target.value);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      <div className={styles.confirm_edits_wrapper}>
        <div className={styles.confirm_edits}>
          <div className={styles.confirm_header}>
            上記の内容でデザイン決定しますか？
          </div>
          <div className={styles.confirm_button_section}>
            <Link
              to={
                totalPageNumber === 1
                  ? "情報入力"
                  : "editsection" + currentPageNumber
              }
              spy={true}
              smooth={true}
              offset={-100}
              duration={500}
            >
              <button className={styles.confirm_button_no}>編集へ戻る</button>
            </Link>
            <button
              onClick={() => {
                if (totalPageNumber === 1) {
                  confirmEdits();
                } else {
                  if (currentPageNumber < totalPageNumber) {
                    const elementName = "editsection" + (currentPageNumber + 1);

                    scroller.scrollTo(elementName, {
                      spy: true,
                      smooth: true,
                      offset: -100,
                      duration: 500,
                    });
                  } else {
                    confirmEdits();
                  }
                }
              }}
              className={styles.confirm_button_yes}
            >
              はい
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PassportPartPhotoReusable;
